var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonseemlesspattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.396,
    height: 18.396,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 623.69,
    y1: 632.42,
    x2: 623.69,
    y2: 626.28,
    gradientTransform: "matrix(0 1.15 -1.2 0 1606.88 -636.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 606.76,
    y1: 740.71,
    x2: 606.76,
    y2: 749.93,
    gradientTransform: "matrix(1.15 0 0 1.2 148.84 -820.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 593.89,
    y1: 686.18,
    x2: 593.89,
    y2: 695.4,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 597.1,
    y1: 683.11,
    x2: 597.1,
    y2: 692.33,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 560.12,
    y1: 638.57,
    x2: 560.12,
    y2: 632.42,
    gradientTransform: "matrix(0 1.15 -1.2 0 778.516 -626.014)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 600.32,
    y1: 680.04,
    x2: 600.32,
    y2: 689.25,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 556.9,
    y1: 635.49,
    x2: 556.9,
    y2: 629.35,
    gradientTransform: "matrix(0 1.15 -1.2 0 778.516 -626.014)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 603.54,
    y1: 676.97,
    x2: 603.54,
    y2: 686.18,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 606.76,
    y1: 673.89,
    x2: 606.76,
    y2: 683.11,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 556.9,
    y1: 650.85,
    x2: 556.9,
    y2: 644.71,
    gradientTransform: "matrix(0 1.15 -1.2 0 778.516 -626.014)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 553.68,
    y1: 647.78,
    x2: 553.68,
    y2: 641.64,
    gradientTransform: "matrix(0 1.15 -1.2 0 778.516 -626.014)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 550.47,
    y1: 644.71,
    x2: 550.47,
    y2: 638.57,
    gradientTransform: "matrix(0 1.15 -1.2 0 778.516 -626.014)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 593.89,
    y1: 670.82,
    x2: 593.89,
    y2: 680.04,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 547.25,
    y1: 641.64,
    x2: 547.25,
    y2: 635.49,
    gradientTransform: "matrix(0 1.15 -1.2 0 778.516 -626.014)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 597.1,
    y1: 667.75,
    x2: 597.1,
    y2: 676.97,
    gradientTransform: "matrix(1.15 0 0 1.2 -679.524 -810.034)",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777",
      stroke: "none",
      strokeWidth: 0.0668112,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "markers fill stroke"
    },
    d: "M0 0h18.396v18.396H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    style: {
      isolation: "isolate",
      fill: "url(#c)"
    },
    d: "M-.064 14.706h3.69v11.08h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    style: {
      isolation: "isolate",
      fill: "url(#d)"
    },
    d: "M3.626 11.016h3.69v11.08h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    style: {
      isolation: "isolate",
      fill: "url(#e)"
    },
    d: "M11.016 14.706h7.38v3.69h-7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    style: {
      isolation: "isolate",
      fill: "url(#f)"
    },
    d: "M7.316 7.326h3.69v11.08h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    style: {
      isolation: "isolate",
      fill: "url(#g)"
    },
    d: "M14.706 11.016h7.38v3.69h-7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    style: {
      isolation: "isolate",
      fill: "url(#h)"
    },
    d: "M11.016 3.626h3.69v11.08h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    style: {
      isolation: "isolate",
      fill: "url(#i)"
    },
    d: "M14.706-.064h3.69v11.08h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    style: {
      isolation: "isolate",
      fill: "url(#j)"
    },
    d: "M-3.754 11.016h7.38v3.69h-7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    style: {
      isolation: "isolate",
      fill: "url(#k)"
    },
    d: "M-.064 7.326h7.38v3.69h-7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    style: {
      isolation: "isolate",
      fill: "url(#l)"
    },
    d: "M3.626 3.626h7.38v3.69h-7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    style: {
      isolation: "isolate",
      fill: "url(#m)"
    },
    d: "M-.064-3.754h3.69v11.08h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    style: {
      isolation: "isolate",
      fill: "url(#n)"
    },
    d: "M7.316-.064h7.38v3.69h-7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    style: {
      isolation: "isolate",
      fill: "url(#o)"
    },
    d: "M3.626-7.444h3.69v11.08h-3.69z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonseemlesspattern);
export default __webpack_public_path__ + "static/media/carbonseemlesspattern.e92d72678f727481906c8427c7664245.svg";
export { ForwardRef as ReactComponent };